import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import clsx from "clsx";
import Rating from "./sub-components/ProductRating";
import ProductModal2 from "./ProductModal2";
import { addToCart } from "../../store/slices/cart-slice";

import { useTranslation } from "react-i18next";
import { CurrencyFormatter } from "../../helpers/currencyFormatter";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { View } from "lucide-react";
import { fetchArticleDetail } from "../../hooks/use-FetchArticles";

import { setLoading } from "../../store/slices/menu-slice";
import { ProductBadges } from "./ProductBadges";
import { API_URL } from "../../config";

const ProductGridListSingle = ({
  product,
  currency,
  cartItem,
  wishlistItem,
  compareItem,
  spaceBottomClass,
}) => {
  const dispatch = useDispatch();
  // const { article } = useSelector((state) => state.article);
  const { loading } = useSelector((state) => state.loader);
  const { configParams } = useSelector((state) => state.paramsWeb);
  const { t, i18n } = useTranslation();

  const [modalShow, setModalShow] = useState(false);
  const [loadingImage, setLoadingImage] = useState(true);
  const finalProductPrice = +(product.price * currency.currencyRate).toFixed(2);
  const finalPrice1 = +((product.price1 || 0) * currency.currencyRate).toFixed(2);
  const finalPrice2 = +((product.price2 || 0) * currency.currencyRate).toFixed(2);

  const handleProductDetail = async (e) => {
    e.stopPropagation();
    try {
      dispatch(setLoading(true));
      await dispatch(fetchArticleDetail(product.sku));
    } catch (error) {
      console.error("Error al cargar detalle:", error);
    } finally {
      setModalShow(true);
      dispatch(setLoading(false));
    }
  };

  return (
    <Fragment>
      <div className={clsx("product-wrap", spaceBottomClass)}>
        <div className={clsx("product-img", loadingImage && "loading")}>
          <div onClick={handleProductDetail}>

             <ProductBadges product={product} t={t} />
           <>
              <SmartImage
                basePath={`${API_URL}/api/v2/Imagenes?src=/ftp_imagenes/articulos/` }
                imageName={product.image[0]}
                alt={product.name}
                width={320}
                height={320}
                onLoadEnd={() => setLoadingImage(false)}
              />
            
            </>
          </div>

          <div className="product-action">
            <div className="pro-same-action pro-cart w-100">
              <button
                onClick={handleProductDetail}
                title="Quick View"
                className=""
              >
                <View size={20} /> Ver
              </button>
            </div>
          </div>
        </div>
        <div className="product-content text-center">
          <h3>{product.name}</h3>
          {product.rating && product.rating > 0 ? (
            <div className="product-rating">
              <Rating ratingValue={product.rating} />
            </div>
          ) : (
            ""
          )}
          <ProductPriceRows
            cash={finalProductPrice}
            debit={finalPrice1}
            credit={finalPrice2}
            i18n={i18n}
            currency={currency}
          />
        </div>
      </div>
      <div className="shop-list-wrap mb-30">
        <div className="row">
          <div className="col-xl-4 col-md-5 col-sm-6">
            <div className="product-list-image-wrap">
              {typeof product === "object" && (
                <div className="product-img">
                  <Link
                    to={process.env.PUBLIC_URL + "/producto/" + product.sku}
                  >
                    <LazyLoadImage
                      className="default-img img-fluid"
                      src={process.env.PUBLIC_URL + product.image[0]}
                      alt={product.name}
                    />
                    {product.image.length > 1 ? (
                      <LazyLoadImage
                        className="hover-img img-fluid"
                        src={process.env.PUBLIC_URL + product.image[1]}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                  </Link>
                  {product.discount || product.new ? (
                    <div className="product-img-badges">
                      {product.discount ? (
                        <span className="pink">-{product.discount}%</span>
                      ) : (
                        ""
                      )}
                      {product.new ? (
                        <span className="purple">{t("general_words.new")}</span>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-8 col-md-7 col-sm-6">
            <div className="shop-list-content">
              <ProductPriceRows
                cash={finalProductPrice}
                debit={finalPrice1}
                credit={finalPrice2}
                i18n={i18n}
                currency={currency}
                list
              />
              {product.rating && product.rating > 0 ? (
                <div className="rating-review">
                  <div className="product-list-rating">
                    <Rating ratingValue={product.rating} />
                  </div>
                </div>
              ) : (
                ""
              )}
              {product.shortDescription ? (
                <p>{product.shortDescription}</p>
              ) : (
                ""
              )}

              <div className="shop-list-actions d-flex align-items-center">
                <div className="shop-list-btn btn-hover">
                  {product.affiliateLink ? (
                    <a
                      href={product.affiliateLink}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {" "}
                      Buy now{" "}
                    </a>
                  ) : product.variation && product.variation.length >= 1 ? (
                    <Link
                      to={`${process.env.PUBLIC_URL}/producto/${product.id}`}
                    >
                      ver detalle
                    </Link>
                  ) : product.stock && product.stock > 0 ? (
                    <button
                      onClick={() => dispatch(addToCart(product))}
                      className={
                        cartItem !== undefined && cartItem.quantity > 0
                          ? "active"
                          : ""
                      }
                      disabled={cartItem !== undefined && cartItem.quantity > 0}
                      title={cartItem !== undefined ? "Ya Añadido" : "Añadir"}
                    >
                      {" "}
                      <i className="pe-7s-cart"></i>{" "}
                      {cartItem !== undefined && cartItem.quantity > 0
                        ? "Ya Añadido"
                        : "Añadir"}
                    </button>
                  ) : (
                    <button disabled className="active">
                      Agotado
                    </button>
                  )}
                </div>

                <div className="shop-list-wishlist ml-10"></div>
                <div className="shop-list-compare ml-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* product modal */}
      <ProductModal2
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
      />
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  cartItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
  currency: PropTypes.shape({}),
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.shape({}),
};

const ProductPriceRows = ({ cash, debit, credit, i18n, currency, list }) => {
  return (
    <div className={list ? "product-list-price tc-product-prices" : "product-price tc-product-prices"}>
      <span className="tc-product-price-row tc-product-price-row--cash">
        <span className="tc-product-price-label">Beneficio en Efectivo</span>
        <span className="tc-product-price-amount">{CurrencyFormatter(cash, i18n, currency)}</span>
      </span>
      {debit > 0 && (
        <span className="tc-product-price-row">
          <span className="tc-product-price-label">Tarjeta Débito</span>
          <span className="tc-product-price-amount">{CurrencyFormatter(debit, i18n, currency)}</span>
        </span>
      )}
      {credit > 0 && (
        <span className="tc-product-price-row">
          <span className="tc-product-price-label">Tarjeta Crédito</span>
          <span className="tc-product-price-amount">{CurrencyFormatter(credit, i18n, currency)}</span>
        </span>
      )}
    </div>
  );
};

const SmartImage = ({
  basePath,
  imageName,
  alt = "",
  width = 320,
  height = 320,
  onLoadEnd = () => {},
  ...props
}) => {
  const [src, setSrc] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = `${basePath}${imageName}`;
    img.onload = () => {
      setSrc(img.src);
      setLoaded(true);
      onLoadEnd();
    };
    img.onerror = () => {
      setSrc("/default/no-image.avif");
      setLoaded(true);
      onLoadEnd();
    };
  }, [imageName, basePath]);

  if (!loaded) {
    return (
      <div
        className="d-flex justify-content-center align-items-center bg-white"
        style={{ width, height }}
      >
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  return (
    <picture>
      {/* Imagen para pantallas pequeñas */}
      <source
        srcSet={`${basePath}sm_${imageName}`}
        media="(max-width: 799px)"
      />
      {/* Imagen principal (desktop o fallback) */}
      <img
        
        src={src+"&fmt=webp&q=80&ar=square&fit=crop&w=1024&fmt=webp&q=80"}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        className="img-fluid object-fit-cover"
        {...props}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/default/no-image.avif";
        }}
      />
    </picture>
  );
};

export default ProductGridListSingle;
